export function isUpdate<T extends { id: number }>(model: T | Omit<T, 'id'>): boolean {
  return (model as T).id !== null;
}
